export default "__VITE_ASSET__BC$tERUx__"